import styled from 'styled-components';
import { Flex, mediaBreakpointMixin } from '@zillow/constellation';

export const StyledFlex = styled(Flex)`
  height: 32px;

  @media ${mediaBreakpointMixin('lg')} {
    height: 48px;
  }
}
`;

export const StyledContentContainer = styled.div`
  min-width: 1px;
  width: 100%;
`;
